const form = {
	"nickname": "",
	"uid": "",
	"name": "",
	"address": "",
	"country": "",
	"province": "",
	"city": "",
	"district": "",
	"postal_code": "",
	"country_dial_code": "",
	"phone_number": "",
	"email": "",
	"address_name": "",
}

const main_state = {
	login: false,
	loader: false,
	lang_json: false,
	isNewForm: true,
	form_list: [],
	form_data: form,
	confirm_type: false,
	msg: false,
	selected_form_id: false,
	isThereError: false
};

const main = (state = main_state, action) => {
	switch (action.type) {
		case "PUT_DATA":
			return { ...state, [action.key]: action.data };
		case "PUT_DATA_FORM":
			return {
				...state,
				form_data: {
					...state.form_data,
					[action.key]: action.data
				}
			};
		case "TOGGLE_LOADER":
			return { ...state, loader: action.data };
		case "TOGGLE_LOADER_HASH":
			return { ...state, loader_hash: action.data };
		default:
			return state;
	}
};

export default main;
